import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service'

@Component({
  selector: 'app-navside-apps-list',
  templateUrl: './navside-apps-list.component.html',
  styleUrls: ['./navside-apps-list.component.sass']
})
export class NavsideAppsListComponent implements OnInit {
peopleLoggedIn;
uid;
  constructor(
    private route: Router,
    private auth: AuthenticationService
  ) { }

  ngOnInit(): void {
    this.auth.getPeopleSignInUid()
    .then( res=> {
      this.uid = res.uid;       
    })
  }

  routeToPeopleDetailPage(){
    this.route.navigateByUrl('people/'+this.uid);
  }
  routeToSponsorListPage(){
    this.route.navigateByUrl('sponsors');
  }
  routeToGovernmentCategoryListPage(){
    this.route.navigateByUrl('government/categories');
  }
  routeToBusinessPopularListPage(){
    this.route.navigateByUrl('popular/businesses');
  }
  routeToBusinessCategoryListPage(){
    this.route.navigateByUrl('business/categories');
  }
  routeToTourpackageListPage(){
    this.route.navigateByUrl('tourpackages');
  }
  routeToHandicraftListPage(){
    this.route.navigateByUrl('handicrafts');
  }
  routeToPaintingListPage(){
    this.route.navigateByUrl('paintings');
  }

}
